import { install } from 'resize-observer'

// Polyfill for iOS < 13
if (!Promise.allSettled) {
    Promise.allSettled = promises => Promise.all(
        promises.map((promise) => promise
            .then(value => ({
                status: 'fulfilled',
                value
            }))
            .catch(reason => ({
                status: 'rejected',
                reason
            })))
    )
}

if (!window.ResizeObserver) {
    install()
}

if (!Array.prototype.at) {
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(
        Array.prototype,
        'at',
        {
            value: function at(n) {
                let i = Math.trunc(n) || 0
                if (i < 0) i += this.length
                if (i < 0 || i >= this.length) return undefined
                return this[i]
            },
            configurable: true,
            writable: true
        }
    )
}

if (!Array.prototype.toSorted) {
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(
        Array.prototype,
        'toSorted',
        {
            value: function(compareFn) {
                if (this == null || this == undefined) {
                    throw new TypeError('Array.prototype.toSorted called on null or undefined')
                }
                const arrayCopy = Array.prototype.slice.call(this)
                return arrayCopy.sort(compareFn)
            },
            configurable: true,
            writable: true
        }
    )
}

if (!Array.prototype.toReversed) {
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(
        Array.prototype,
        'toReversed',
        {
            value: function() {
                if (this == null || this == undefined) {
                    throw new TypeError('Array.prototype.toReversed called on null or undefined')
                }
                const arrayCopy = Array.prototype.slice.call(this)
                if (this.length < 2) return arrayCopy
                arrayCopy.reverse()
                return arrayCopy
            },
            configurable: true,
            writable: true
        }
    )
}

// ---- Non-standard Javascript methods ----
// eslint-disable-next-line no-extend-native
Object.defineProperty(String.prototype, 'capitalize', {
    value: function() {
        if (this.length === 0) return ''
        return this.charAt(0).toUpperCase() + this.slice(1)
    },
    enumerable: false
})
